<!--
 * @Description: 加载动画
 * @Author: 山淑兰
 * @Date: 2020-01-06 11:44:36
 * @LastEditTime : 2020-01-14 20:13:23
 * @LastEditors  : 山淑兰
 -->
<template>
  <div id="loading">
    <div class="loading_con">
      <div class="loading-blue"></div>
      <div><img src="@assets/loading.png" alt /></div>

      <div class="loadingText">努力加载中...</div>
    </div>
  </div>
</template>
<script>
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Loading extends Vue {}
</script>
<style lang="scss" scoped>
@keyframes fadeUp {
  0% {
    height: 0%;
  }
  100% {
    height: 97%;
  }
}
#loading {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  overflow: hidden;
}
.loading_con {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #eee;
}
#loading img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.loading-blue {
  animation: fadeUp 2s linear 1s infinite alternate;
  width: 97%;
  position: absolute;
  bottom: 1px;
  left: 1%;
  background: rgb(17, 122, 241);
}
.loadingText {
  position: absolute;
  bottom: -36%;
  width: 200px;
  left: 0;
  color: #fff;
  font-size: 20px;
}
</style>
